function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.026 13.293l-1.741-.307a.5.5 0 00-.502.771l2.393 3.562a.75.75 0 001.064.187l3.467-2.528a.5.5 0 00-.208-.896l-2.009-.354C6.533 8.882 10.842 5.25 16 5.25c3.977 0 7.452 2.16 9.312 5.376l2.164-1.252A13.245 13.245 0 0016 2.75c-6.39 0-11.724 4.524-12.974 10.543zM16 26.75c5.157 0 9.466-3.632 10.51-8.478l-2.01-.354a.5.5 0 01-.207-.896l3.466-2.528a.75.75 0 011.065.187l2.393 3.562a.5.5 0 01-.502.77l-1.742-.306C27.723 24.727 22.39 29.25 16 29.25a13.245 13.245 0 01-11.477-6.624l2.164-1.252A10.745 10.745 0 0016 26.75z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 13.75a.75.75 0 01.75-.75h8.5a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-8.5a.75.75 0 01-.75-.75v-.75z",
  fill: "url(#deal_svg__paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 18.5a.75.75 0 01.75-.75h8.5a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-8.5a.75.75 0 01-.75-.75v-.75z",
  fill: "url(#deal_svg__paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "deal_svg__paint0_linear",
  x1: 12.875,
  y1: 13,
  x2: 20.294,
  y2: 15.424,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "deal_svg__paint1_linear",
  x1: 12.875,
  y1: 13,
  x2: 20.294,
  y2: 15.424,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgDeal = function SvgDeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgDeal;